export default "__VITE_ASSET__037e9738__"